import {SponsorshipType} from "@/types/spellify/sponshorship";
import styles from './SponsorshipOverlay.module.scss'
import {useEffect, useState} from "react";
import Button from "@/components/UI/Button/Button";
import ReactGA from "react-ga4";
import { useSponsorshipBackground} from "@/utils/sponsorships";

type Props = {
  sponsorship: SponsorshipType | null
}

const SponsorshipOverlay = ({sponsorship}: Props) => {

  const [open, setOpen] = useState(true)
  const sponsorshipBackground = useSponsorshipBackground(sponsorship)

  useEffect(() => {
    if (open && sponsorship) {
      ReactGA.event({
        category: 'Sponsorship',
        action: 'Viewed',
        label: sponsorship.name
      })
    }
  }, [open]);

  const handleSponsorshipClick = (from: string) => {
    if (sponsorship) {
      ReactGA.event({
        category: 'Sponsorship',
        action: `Clicked ${from}`,
        label: sponsorship.name
      })
    }
  }

  if (!sponsorship) return null

  if (!open) return (
    <>
      <div className={styles.tabContainer}>
        <a href={sponsorship.landingPage} target="_blank" rel="noreferrer" onClick={() => handleSponsorshipClick('sidebar')}>
          <button className={styles.tab}>
            Sponsored by {sponsorship.name} <img src={sponsorship.logo} alt={sponsorship.name} height="20px"/>
          </button>
        </a>
      </div>
    </>
)

return (
  <div className={styles.overlay} style={sponsorshipBackground}>
      <div className={styles.inner}>
        <div className={styles.logo}>
          <img src={sponsorship.logo} alt={sponsorship.name} className={styles.logo}/>
        </div>
        <div className={styles.description}>
          <div className={styles.sponsoredBy}>Today's Spellify is sponsored by:</div>
          <h2 className={styles.title}>{sponsorship.name}</h2>
          <p>{sponsorship.description}</p>
          <div className={styles.subContainer}>
            {sponsorship.subImages.map((image, index) => (
              <div key={index} className={styles.sub}>
                <a href={sponsorship.landingPage} target="_blank" rel="noreferrer" onClick={() => handleSponsorshipClick('image')}>
                  <img src={image} alt={sponsorship.subImageLabels[index]} className={styles.subImage}/>
                </a>

                <label className={styles.subLabel}>{sponsorship.subImageLabels[index].toUpperCase()}</label>
              </div>
            ))}
          </div>

          <a href={sponsorship.landingPage} target="_blank" rel="noreferrer" onClick={() => handleSponsorshipClick('call to action')}>{sponsorship.callToAction}</a>
        </div>
        <Button onClick={() => setOpen(false)}>Play Spellify</Button>
      </div>
    </div>
  )
}

export default SponsorshipOverlay